export default __webpack_public_path__ + "static/media/logo.2271a548.png";